import { type Hex, isHex } from 'viem';

class InvalidHexError extends Error {
  readonly name = 'InvalidHexError';

  readonly value: string;

  constructor({ value }: { value: string }) {
    super('Must be a valid hex value that starts with 0x');

    this.value = value;
  }
}

export function assertIsHex(value: string): asserts value is Hex {
  if (!isHex(value, { strict: false })) throw new InvalidHexError({ value });
}

export function assertIsHexList(list: string[]): asserts list is Hex[] {
  list.forEach(assertIsHex);
}
